module.exports = require("@mui/material/Slider");